import React, { Component } from 'react'
import SectionWrapper from "../../sectionwrapper.component.jsx";
import { TextContentSectionContent } from "./TextContentSectionContent.tsx"
import { injectIntl } from "react-intl"

class TextContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            isDummy: this.props.isDummy || false,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isDummy: nextProps.isDummy || false,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.section) {
            return <div />
        }

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <TextContentSectionContent {...this.state} content={this.state.section.attributes.content} intl={this.props.intl} />
            </SectionWrapper>
        );
    }
}

export default injectIntl(TextContentSection)


// WEBPACK FOOTER //
// ./src/template/sections/content/text/section.component.jsx